import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const PolicyOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PolicyCard = styled.div`
  width: 560px;
  max-width: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid ${theme.colors.base_300};
  overflow: hidden;
`;

export const PolicyCardHeader = styled.div`
  padding: 30px 30px 0 30px;
  text-align: center;
`;

export const PolicyLogo = styled.img`
  display: block;
  margin: 0 auto 16px auto;
  width: 140px;
  max-width: 100%;
  height: auto;
`;

export const PolicyTitle = styled.h2`
  font-family: ${theme.fonts.title};
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 4px 0;
  color: ${theme.colors.base_800};
`;

export const PolicyCardBody = styled.div`
  flex: 1;
  padding: 20px 30px;
  overflow-y: auto;
  font-family: ${theme.fonts.body};
`;

export const PolicyBodyText = styled.p`
  font-family: ${theme.fonts.body};
  font-size: 13px;
  line-height: 1.6;
  color: ${theme.colors.black};
  margin: 0 0 16px 0;
`;

export const PolicySummary = styled.div`
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.inputOutline};
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  font-size: 13px;
  line-height: 1.7;
  color: ${theme.colors.black};
  font-family: ${theme.fonts.body};
  max-height: 280px;
  overflow-y: auto;

  h4 {
    font-family: ${theme.fonts.title};
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 6px 0;
    color: ${theme.colors.black};
  }

  ul {
    margin: 0 0 12px 0;
    padding-left: 18px;
  }

  li {
    margin-bottom: 4px;
  }

  p {
    margin: 0 0 12px 0;
  }
`;

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: ${theme.fonts.body};
  color: ${theme.colors.dkgrey};
  text-decoration: none;
  margin-bottom: 20px;

  &:hover {
    text-decoration: underline;
    color: ${theme.colors.dkgrey};
  }

  svg {
    width: 16px;
    height: 16px;
    fill: ${theme.colors.dkgrey};
  }

  &:hover svg {
    fill: ${theme.colors.dkgrey};
  }
`;

export const PolicyCardFooter = styled.div`
  padding: 20px 30px;
  border-top: 1px solid ${theme.colors.base_300};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EffectiveDate = styled.span`
  font-family: ${theme.fonts.body};
  font-size: 12px;
  color: ${theme.colors.base_500};
  font-weight: 500;
  display: block;
  margin-top: 4px;
`;
